const modulesFiles = require.context('./', false, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  if(modulePath === './index.js') return modules;
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default {
  ...modules
};
